module.exports = __webpack_public_path__ + "img/logo.944ca676.png";